import { render, staticRenderFns } from "./BoxCode.vue?vue&type=template&id=439c398c&scoped=true"
import script from "./BoxCode.vue?vue&type=script&lang=js"
export * from "./BoxCode.vue?vue&type=script&lang=js"
import style0 from "./BoxCode.vue?vue&type=style&index=0&id=439c398c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439c398c",
  null
  
)

export default component.exports